"use client"

import * as React from "react"
import dynamic from "next/dynamic"

import { ScrollToTop } from "@/components/scroll-to-top"

import { ThemeProvider } from "./theme-provider"

const Analytics = dynamic(
  () =>
    import("@vercel/analytics/next").then((mod) => ({
      default: mod.Analytics,
    })),
  {
    ssr: false,
  }
)

const NextTopLoader = dynamic(() => import("nextjs-toploader"), {
  ssr: false,
})

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <>
      <ThemeProvider
        attribute="class"
        defaultTheme="light"
        disableTransitionOnChange
      >
        {children}
        <Analytics />
        <ScrollToTop />
        <NextTopLoader showForHashAnchor={false} />
      </ThemeProvider>
    </>
  )
}
